import React, { useState, useEffect } from "react";
import menuRules from "../../data/menuData.json";
import { generateCalendarDays } from "./calendarUtils";
import fishIcon from "../../assets/images/fishIcon.png";
import fireIcon from "../../assets/images/Fire.png";
import madeInLove from "../../assets/images/Made with Love.png";
import MenuModal from "./CalendarMenuModal";
import { getMonthlyMenu } from "../../helper/backend-methods";
import AppLoader from "../../components/AppLoader";
import { useNavigate, useSearchParams } from "react-router-dom";

const MenuCalendar = () => {
  const history = useNavigate();
  const [searchParams] = useSearchParams();
  const openModaltoday = searchParams.get('today');
  const [loading, setLoading] = useState(false);
  const [monthlyMenu, setMonthlyMenu] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalItems, setModalItems] = useState([]);
  const [modalDate, setModalDate] = useState(null);
  const [isTodayModal, setIsTodayModal] = useState(false);

  const today = new Date();

  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());

  const days = generateCalendarDays(year, month);

  const getMenuForDate = (date) => {
    const dateString = date.toISOString().split("T")[0];

    const apiData = monthlyMenu.find((item) => {
      const itemDate = new Date(item.Date).toISOString().split("T")[0];
      return itemDate === dateString;
    });

    if (apiData && apiData.Products && apiData.Products.length > 0) {
      return {
        isSpecial: apiData.IsSpecial,
        title: apiData.Title,
        subtitle: apiData.Subtitle,
        icon: apiData.Day === 5 ? "fish" : null,
        highlight: apiData.Day === 5,
        items: apiData.Products.map((product) => ({
          name: product.ProductName,
          price: product.Price,
          id: product.ProductId,
          desc: product.ShortDescription,
          productAttributes: product.productAttributes,
          itemImage: product.ProductPictures[0].Url
        })),
      };
    }

    return {
      isSpecial: false,
      title: null,
      subtitle: null,
      icon: null,
      highlight: false,
      items: [],
    };
  };

  const nextMonth = () => {
    if (month === 11) {
      setMonth(0);
      setYear((y) => y + 1);
    } else setMonth((m) => m + 1);
  };

  const prevMonth = () => {
    if (month === 0) {
      setMonth(11);
      setYear((y) => y - 1);
    } else setMonth((m) => m - 1);
  };

  const getMenu = () => {
    setLoading(true);
    getMonthlyMenu({ month: month + 1, year: year })
      .then(({ data }) => {
        if (data.Status) {
          setMonthlyMenu(data.Data);
          setLoading(false);
          if(openModaltoday === 'true') {

            const todayMenu = data.Data.find((item) => {
              const itemDate = new Date(item.Date).toDateString();
              const todayDate = today.toDateString();
              return itemDate === todayDate;
            });
            if (todayMenu) {
              let todayMenuItems = [];
              if(todayMenu.Products && todayMenu.Products.length > 0) {
                todayMenuItems = todayMenu.Products.map((product) => ({
                  name: product.ProductName,
                  price: product.Price,
                  id: product.ProductId,
                  desc: product.ShortDescription,
                  productAttributes: product.productAttributes,
                }))
              }
              setModalItems(todayMenuItems);
              setModalDate(today);
              setIsTodayModal(true);
              setModalOpen(true);
            }
          }
        }
      })
      .catch((err) => {
        setMonthlyMenu([]);
        setLoading(false);
        console.error("Error fetching categories:", err);
      });
  };

  useEffect(() => {
    getMenu();
  }, [month, year]);

  return (
    <>
      <div className="wrapper">
        <section className="calendar-hero">
          <div>
            <h5 className="script">
              <img src={madeInLove} alt="Made in Love" className="scriptImg" />
            </h5>
            <h2>THIS MONTH'S DELICIOUS PICKS</h2>
            <p>From hearty breakfasts to classic comfort meals, find your favorites here.</p>
            <button onClick={() => history("/menu")} className="primary-btn">VIEW FULL MENU</button>
          </div>
        </section>
        <section className="calendar-wrapper">
          <div className="calendar-inner">
            <header className="calendar-header">
              <button onClick={prevMonth}>‹</button>
              <h2>
                {new Date(year, month).toLocaleString("en-US", {
                  month: "long",
                  year: "numeric",
                })}
              </h2>
              <button onClick={nextMonth}>›</button>
            </header>

            <div className="week-labels">
              {[
                "Savory Sunday",
                "Mouthful Monday",
                "Tasty Tuesday",
                "Wicked Wednesday",
                "Thrilled Thursday",
                "Fry-Yay Friday",
                "Savor Saturday",
              ].map((day) => (
                <div key={day}>{day}</div>
              ))}
            </div>

            {loading ? (
              <div className="loader-center">
                <AppLoader />
              </div>
            ) : (
              <div className="calendar-grid">
                {days.map((date, i) => {
                  if (!date) return <div key={i} className="empty" />;

                  const menu = getMenuForDate(date);
                  const isToday = date.toDateString() === today.toDateString();
                  return (
                    <div
                      key={i}
                      className={`cell ${isToday ? "active" : ""} ${date.getDay() === 5 ? "friday" : ""}`}
                      data-has-items={menu.items && menu.items.length > 0}
                      onClick={() => {
                        if (menu.items && menu.items.length > 0) {
                          setModalItems(menu.items);
                          setModalDate(date);
                          setIsTodayModal(isToday);
                          setModalOpen(true);
                        }
                      }}
                    >
                      <div className="overlay"></div>
                      <div className="eye-icon-white">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(255,255,255,1)">
                          <path d="M1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12ZM12.0003 17C14.7617 17 17.0003 14.7614 17.0003 12C17.0003 9.23858 14.7617 7 12.0003 7C9.23884 7 7.00026 9.23858 7.00026 12C7.00026 14.7614 9.23884 17 12.0003 17ZM12.0003 15C10.3434 15 9.00026 13.6569 9.00026 12C9.00026 10.3431 10.3434 9 12.0003 9C13.6571 9 15.0003 10.3431 15.0003 12C15.0003 13.6569 13.6571 15 12.0003 15Z"></path>
                        </svg>
                      </div>
                      <div className={`${isToday ? "active-box" : ""}`}>
                        <div className={date.getDay() === 5 ? "date-box-header" : "box-header"}>
                          {date.getDay() === 5 && <img src={fishIcon} className="fish-icon" />}
                          <span className="date">{date.getDate()}</span>
                        </div>
                        {isToday && (
                          <span className="special-hd">
                            <img src={fireIcon} className="fire-icon" />
                            Today’s Special
                          </span>
                        )}
                        {/* {menu.isSpecial && <div className="today-special">{menu.title}</div>} */}
                        <ul>
                          {menu.items &&
                            menu.items.length > 0 &&
                            menu.items.slice(0, 2).map((item, idx) => {
                              const isLastVisible = idx === 1 && menu.items.length > 2;

                              return (
                                <li key={idx}>
                                  {item.name}
                                  {isLastVisible && <span className="inline-dots"> ...</span>}
                                </li>
                              );
                            })}

                          {((menu.items && menu.items.length > 2) && isToday) && (
                            <li>
                              <button
                                className={`view-all-btn ${isToday ? "spl" : ""}`}
                                onClick={() => {
                                  setModalItems(menu.items);
                                  setModalDate(date);
                                  setIsTodayModal(isToday);
                                  setModalOpen(true);
                                }}
                              >
                                View all &gt;&gt;
                              </button>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </section>
      </div>
      <MenuModal
        open={modalOpen}
        toggle={() => setModalOpen(false)}
        items={modalItems}
        date={modalDate || new Date()}
        isToday={isTodayModal}
      />
    </>
  );
};

export default MenuCalendar;
